import {Dispatch, SetStateAction} from "react";
import {useModal} from "../../../../../hooks";
import {useUpdateDeadlineProgress} from "../../../deadline/list/hooks/useUpdateDeadlineProgress";
import {OrdersDetailType} from "../interface";
import {useUpdateOrderProgress} from "../../list/hooks/useUpdateOrderProgress";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";
import {useQueryClient} from "@tanstack/react-query";
import {useParams} from "react-router-dom";
import {readShipmentDeliveryConfirm, readShipmentDetail} from "../../../../../api/order/OrdersApi";

interface PropsType {
    tab: string
    setTab: Dispatch<SetStateAction<string>>
    ordersDetail: OrdersDetailType
    isModify: string
    isDeadline: boolean | undefined
}

export default function TabNav({tab, setTab, ordersDetail, isModify, isDeadline}: PropsType) {
    const {id} = useParams()
    const {handleModal} = useModal();

    const clickTab = (str: string) => {
        if (isModify !== "") {
            handleModal({
                isOpen: true,
                contents: "편집 중에는 탭을 변경할 수 없습니다.",
                type: "alert",
            });
        } else {
            setTab(str)
        }
    }

    const {mutate: mutateUpdateDeadlineProgress} = useUpdateDeadlineProgress({
        closeCallback: () => {
        }
    })
    const btnToggleFinish = (key: "Y" | "N") => {
        const list: any = [{...ordersDetail, endFlag: key}]

        handleModal({
            isOpen: true,
            contents: key === "Y" ? "마감 처리하시겠습니까?" : "마감 취소하시겠습니까?",
            type: "confirm",
            callback: () => mutateUpdateDeadlineProgress(list)
        })
    }

    const qc = useQueryClient()
    const closeCallbackU = () => {
        qc.invalidateQueries({queryKey: ["readShipmentDetail", id as string]})
        qc.invalidateQueries({queryKey: ["readShipmentDeliveryConfirm", id as string]})
    }
    const {mutate: mutateUpdateOrderProgress} = useUpdateOrderProgress({closeCallback: closeCallbackU})
    const btnChangeProgress = (key: "shipmentRequest" // 출하요청
        | "shipmentRequestCancel" // 출하요청 취소
        | "shipment" // 출하
        | "shipmentCancel" // 출하 취소
        | "transfer" // 이관
        | "transferCancel" // 이관 취소
    ) => {
        let msg = "";
        let newProgress = 0;

        switch (key) {
            case "shipmentRequest":
                msg = "출하요청 하시겠습니까?"
                newProgress = 100000001
                break;
            case "shipmentRequestCancel":
                msg = "출하요청을 취소하시겠습니까?"
                newProgress = 100000000
                break;
            case "shipment":
                msg = "출하 하시겠습니까?"
                newProgress = 100000002
                break;
            case "shipmentCancel":
                msg = "출하 취소하시겠습니까?"
                newProgress = 100000001
                break;
            case "transfer":
                msg = "이관 하시겠습니까?"
                newProgress = 100000003
                break;
            case "transferCancel":
                msg = "이관 취소하시겠습니까?"
                newProgress = 100000002
                break;
        }

        handleModal({
            isOpen: true,
            contents: msg,
            type: "confirm",
            callback: () => mutateUpdateOrderProgress([{
                newShipmentId: ordersDetail.newShipmentId,
                progress: newProgress
            }])
        });
    }

    return <div className="mybtns_group">
        <div className="btn-group" role="group" aria-label="">
            <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-1")}>{!isDeadline ? "수주" : "마감"}정보
            </button>
            <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-2")}>품목정보
            </button>
            <button type="button" className={tab == "tab-3" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-3")}>PTA 레벨
            </button>
            <button type="button" className={tab == "tab-4" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-4")}>이전 결제 건
            </button>
            <button type="button" className={tab == "tab-5" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-5")}>출하자료
            </button>
        </div>
        <div className="mybtns_group_toolbar">
            {!isDeadline
                ? <AuthorityChecker authorityNames={['shipmentWriteYn']}>
                    {ordersDetail.newPProgress === 100000000 && // 수주
                        <button className="btn btn-success w-80px px-0"
                                onClick={() => btnChangeProgress("shipmentRequest")}>출하요청
                        </button>
                    }
                    {ordersDetail.newPProgress === 100000001 && // 출하 요청
                        <>
                            <button className="btn btn-outline-success px-0"
                                    onClick={() => btnChangeProgress("shipmentRequestCancel")}>출하요청 취소
                            </button>
                            <button className="btn btn-primary w-80px px-0"
                                    onClick={() => btnChangeProgress("shipment")}>출하
                            </button>
                        </>
                    }
                    {ordersDetail.newPProgress === 100000002 && // 출하
                        <>
                            <button className="btn btn-outline-primary w-80px px-0"
                                    onClick={() => btnChangeProgress("shipmentCancel")}>출하취소
                            </button>
                            <button className="btn btn-info w-80px px-0 ms-5px"
                                    onClick={() => btnChangeProgress("transfer")}>이관
                            </button>
                        </>
                    }
                    {ordersDetail.newPProgress === 100000003 && // 이관
                        <button className="btn btn-outline-info w-80px px-0"
                                onClick={() => btnChangeProgress("transferCancel")}>이관취소
                        </button>
                    }
                </AuthorityChecker>
                : <AuthorityChecker authorityNames={['endWriteYn']}>
                    {ordersDetail.endState === "마감"
                        ? <button className="btn btn-outline-info w-80px px-0"
                                  onClick={() => btnToggleFinish("N")}>마감 취소
                        </button>
                        : <button className="btn btn-info color2 w-80px px-0"
                                  onClick={() => btnToggleFinish("Y")}>마감
                        </button>
                    }
                </AuthorityChecker>}
        </div>
    </div>
}